import React, { useState } from "react";
import { Form, Button, Icon, Label } from "semantic-ui-react";
import { isEmpty, map } from "lodash";

const options = [
  { key: "twitter", text: "Twitter", value: "twitter" },
  { key: "facebook", text: "Facebook", value: "facebook" },
  { key: "instagram", text: "Instagram", value: "instagram" },
  { key: "linkedin", text: "LinkedIn", value: "linkedin" },
  { key: "youtube", text: "YouTube", value: "youtube" },
  { key: "pinterest", text: "Pinterest", value: "pinterest" },
  { key: "snapchat", text: "Snapchat", value: "snapchat" },
];

const SocialLinks = ({ links, handleSocialLinksButton }) => {
  const [socialLink, setSocialLink] = useState("");
  const [socialMediaOption, setSocialMediaOption] = useState();
  const [dirty, setDirty] = useState(false);
  const [error, setError] = useState();

  const handleChange = (e) => setSocialLink(e.target.value);

  const sanitizeUrl = (rawUrl) => {
    if (!rawUrl) {
      return null;
    }
    const trimmed = rawUrl.trim();
    if (!trimmed) {
      return null;
    }
    const protocolRegex = /^(https?):/i;
    const hasProtocol = protocolRegex.test(trimmed);
    const candidate = hasProtocol ? trimmed : `https://${trimmed}`;
    try {
      const url = new URL(candidate);
      if (url.protocol === "http:" || url.protocol === "https:") {
        return url.toString();
      }
      return null;
    } catch (e) {
      return null;
    }
  };

  const handleSubmit = () => {
    let currentLink = socialLink;

    if (dirty && (socialLink || "").toLowerCase().indexOf(socialMediaOption) < 0) {
      setError({
        content: `Please enter a valid ${socialMediaOption} link`,
        pointing: "above",
      });
      return;
    }

    const sanitized = sanitizeUrl(currentLink);
    if (!sanitized) {
      setError({
        content: "Please enter a valid URL starting with http:// or https://",
        pointing: "above",
      });
      return;
    }

    handleSocialLinksButton(sanitized);
    setSocialLink("");
    setError(undefined);
    setSocialMediaOption();
  };

  const removeSocialLink = (link) => handleSocialLinksButton(link, true);

  return (
    <>
      <Form.Group
        unstackable
        width={3}
        style={{ paddingTop: 23 }}
      >
        <Form.Select
          className="social-select"
          placeholder="SELECT"
          options={options}
          onChange={(e, selected) => setSocialMediaOption(selected.value)}
        />
        <Form.Input
          width={11}
          placeholder="http://www.example.com/twitter"
          onChange={handleChange}
          value={socialLink}
          onBlur={() => {
            if (socialLink.trim().length > 0) {
              setDirty(true);
            } else {
              setDirty(false);
            }
          }}
          error={error}
        />
        <div>
          <Button
            icon={<Icon name="plus" />}
            style={{ background: "none", color: "#bc1f2f" }}
            onClick={handleSubmit}
            disabled={!dirty}
          />
        </div>
      </Form.Group>
      {!isEmpty(links) && (
        <Label.Group className="podcasts" style={{ paddingBottom: 15 }}>
          {map(links, (link, i) => {
            const safeLink = sanitizeUrl(link);
            return (
              <div key={i} style={{ paddingBottom: 10 }}>
                <Label style={{ color: "#fff", backgroundColor: "#ababab", borderRadius: 0 }}>
                  {safeLink ? (
                    <a
                      href={safeLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "white", opacity: "1" }}
                    >
                      {link}{" "}
                    </a>
                  ) : (
                    <span style={{ color: "white", opacity: "1" }}>
                      {link}{" "}
                    </span>
                  )}
                  <Icon name="close" onClick={() => removeSocialLink(safeLink || link)} />
                </Label>
              </div>
            );
          })}
        </Label.Group>
      )}
    </>
  );
};

export default SocialLinks;
